import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import { PATH_WORKFLOW_EMAIL_TEMPLATES } from '@/lib/constants/api'
import buildInitialState from '@/store/helpers/buildInitialState'
import updateStatus from '@/store/helpers/updateStatus'
import { notifyError } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const workflowEmailTemplates = {
  namespaced: true,
  state: buildInitialState({
    workflowEmailTemplateList: []
  }),
  getters: {
    getField
  },
  actions: {
    getWorkflowEmailTemplates ({ commit, dispatch }, filters = {}) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Loading templates, please wait...' })

      return api.doGet({ path: PATH_WORKFLOW_EMAIL_TEMPLATES, parameters: filters })
        .then(json => json.data)
        .then(templates => {
          commit('updateStatus', { status: COMPLETE })
          commit('setWorkflowEmailTemplates', templates)
          return templates
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to load templates')
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    // Does not commit to workflowEmailTemplateList, so it won't fight WorkflowEmailTemplateList.vue
    // over shared list state when both are mounted at the same time.
    getActiveWorkflowEmailTemplateOptions ({ dispatch }, filters = {}) {
      return api.doGet({ path: PATH_WORKFLOW_EMAIL_TEMPLATES, parameters: filters })
        .then(json => json.data || [])
        .catch(() => {
          notifyError(dispatch, 'Unable to load email templates')
          return []
        })
    },
    deactivateWorkflowEmailTemplate ({ dispatch }, template) {
      showProgressModal({ dispatch, message: 'Deactivating template, please wait...' })
      return api.doPut({ path: PATH_WORKFLOW_EMAIL_TEMPLATES, data: { ...template, isActive: false } })
        .then(response => {
          if (!response.data) {
            throw new Error(response.errorMessage || 'Unable to deactivate template')
          }
          return response.data
        })
        .catch(error => {
          notifyError(dispatch, error || 'Unable to deactivate template')
          throw error
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    }
  },
  mutations: {
    updateStatus,
    updateField,
    setWorkflowEmailTemplates (state, templates) {
      state.workflowEmailTemplateList = templates
    }
  }
}

export default workflowEmailTemplates
